const ConsignmentPurchase = `
  id
  consigneeName
  companyId
  colAddress
  colAddress2
  colAddress3
  colCompany
  colContactId
  colCounty
  colCountryId
  colName
  colPostcode
  colTown
  consigneeCompany
  credit
  currencyId
  date
  due
  exchange
  currency {
    id
    code
    description
    name
  }
  consignmentWorks {
    consignmentId
    discount
    discountRate
    fabCost
    fabRate
    grossProfit
    price
    ref
    share
    updatedAt
    user {
      id
      name
    }
  }
  type {
    id
    description
  }
  typeId
`;

export default ConsignmentPurchase;
